export default __webpack_public_path__ + "static/media/slide8.90ef8a6b.png";